<template>
    <svg
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-12 cursor-pointer"
    >
        <g filter="url(#filter0_d_26321_34001)">
            <path
                d="M33.4795 1H8.52054C4.36706 1 1 4.31105 1 8.39544V33.6046C1 37.6889 4.36706 41 8.52054 41H33.4795C37.6329 41 41 37.6889 41 33.6046V8.39544C41 4.31105 37.6329 1 33.4795 1Z"
                fill="white"
            />
            <path
                d="M32.6864 2.13281H9.30635C5.39845 2.13281 2.23047 5.24809 2.23047 9.09099V32.9059C2.23047 36.7488 5.39845 39.8641 9.30635 39.8641H32.6864C36.5943 39.8641 39.7623 36.7488 39.7623 32.9059V9.09099C39.7623 5.24809 36.5943 2.13281 32.6864 2.13281Z"
                fill="#DDDDDD"
            />
            <path
                d="M33.3635 3.98633H8.6237C6.02911 3.98633 3.92578 6.05467 3.92578 8.6061V33.5491C3.92578 36.1005 6.02911 38.1688 8.6237 38.1688H33.3635C35.9581 38.1688 38.0614 36.1005 38.0614 33.5491V8.6061C38.0614 6.05467 35.9581 3.98633 33.3635 3.98633Z"
                fill="#BBBBBB"
            />
            <path
                d="M33.35 5.08008H8.64242C6.63508 5.08008 5.00781 6.68028 5.00781 8.65422V33.4958C5.00781 35.4697 6.63508 37.0699 8.64242 37.0699H33.35C35.3573 37.0699 36.9846 35.4697 36.9846 33.4958V8.65422C36.9846 6.68028 35.3573 5.08008 33.35 5.08008Z"
                fill="#D5D5D5"
            />
            <path
                d="M34.4647 34.6487C34.4647 34.6487 34.4453 36.702 33.3369 37.0695H8.64866C7.54023 36.702 7.52734 34.6487 7.52734 34.6487L9.76997 32.4688H32.222L34.4647 34.6487Z"
                fill="#DDDDDD"
            />
            <path
                d="M9.77018 9.83207V32.4747L7.52755 34.6546C5.56203 34.4835 5.00781 33.5013 5.00781 33.5013V8.65336C5.00781 8.65336 5.56203 7.6711 7.52755 7.5L9.77018 9.83207Z"
                fill="#E6E6E6"
            />
            <path
                d="M34.4647 7.50086L32.222 9.83293H9.76997L7.52734 7.50086C7.52734 7.50086 7.54668 5.44763 8.64866 5.08008H33.3369C34.4453 5.44763 34.4647 7.50086 34.4647 7.50086Z"
                fill="#F0F0F0"
            />
            <path
                d="M8.64886 5.08008C7.54044 5.44763 7.52755 7.50086 7.52755 7.50086C5.56203 7.67197 5.00781 8.65422 5.00781 8.65422C5.00781 6.68337 6.63823 5.08641 8.64242 5.08641H8.65531L8.64886 5.08008Z"
                fill="white"
            />
            <path
                d="M36.9834 33.5024C36.9834 35.4733 35.353 37.0702 33.3488 37.0702H33.3359C34.4444 36.7027 34.4637 34.6495 34.4637 34.6495C36.4228 34.4783 36.9834 33.4961 36.9834 33.4961V33.5024Z"
                fill="white"
            />
            <path
                d="M36.9834 8.64836C36.9834 8.64836 36.4228 7.66611 34.4637 7.495C34.4637 7.495 34.4444 5.44177 33.3359 5.07422H33.3488C35.353 5.07422 36.9834 6.67118 36.9834 8.64203V8.64836Z"
                fill="white"
            />
            <path
                d="M8.64749 37.0698H8.63461C6.63042 37.0698 5 35.4728 5 33.502C5 33.502 5.55421 34.4842 7.51974 34.6553C7.51974 34.6553 7.53907 36.7085 8.64105 37.0761L8.64749 37.0698Z"
                fill="white"
            />
            <path d="M32.2216 9.83203H9.76953V32.4746H32.2216V9.83203Z" fill="white" />
            <g clip-path="url(#clip0_26321_34001)">
                <path
                    d="M20.2985 20.9063L24.7463 16.4293C25.0847 16.0886 25.0847 15.5313 24.7463 15.1914L23.6302 14.068C23.2918 13.7273 22.738 13.7273 22.4003 14.068L16.2516 20.2563C16.0754 20.4345 15.9927 20.6715 16.0005 20.9063C15.9927 21.141 16.0746 21.378 16.2516 21.5562L22.4003 27.7453C22.7388 28.086 23.2925 28.086 23.6302 27.7453L24.7463 26.6219C25.0847 26.2812 25.0847 25.7239 24.7463 25.384L20.2985 20.907V20.9063Z"
                    fill="#BFBFBF"
                />
                <path
                    d="M20.2985 20.0938L24.7463 15.6168C25.0847 15.2761 25.0847 14.7188 24.7463 14.3789L23.6302 13.2555C23.2918 12.9148 22.738 12.9148 22.4003 13.2555L16.2516 19.4438C16.0754 19.622 15.9927 19.859 16.0005 20.0938C15.9927 20.3285 16.0746 20.5655 16.2516 20.7437L22.4003 26.9328C22.7388 27.2735 23.2925 27.2735 23.6302 26.9328L24.7463 25.8094C25.0847 25.4687 25.0847 24.9114 24.7463 24.5715L20.2985 20.0945V20.0938Z"
                    fill="#201D1D"
                />
            </g>
        </g>
        <defs>
            <filter
                id="filter0_d_26321_34001"
                x="0"
                y="0"
                width="54"
                height="54"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="6" dy="6" />
                <feGaussianBlur stdDeviation="3.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0" />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_26321_34001"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_26321_34001"
                    result="shape"
                />
            </filter>
            <clipPath id="clip0_26321_34001">
                <rect width="9" height="15" fill="white" transform="translate(16 13)" />
            </clipPath>
        </defs>
    </svg>
</template>
